import React from 'react'
import useHubSpotForm from 'hooks/useHubSpotForm'
import classnames from 'classnames/bind'
import LabelTitleText from 'components/shared/LabelTitleText'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const ContactForm = ({ className, id, formId, portalId, formIntro }) => {
  const formattedId = `contact-form-${id}`

  useHubSpotForm({
    portalId,
    formId,
    target: `#${formattedId}`,
  })

  return (
    <>
      <div id="contact" className={cx(css.ContactForm, className)}>
        {formIntro && (
          <LabelTitleText
            className={css.formIntro}
            titleProps={{
              size: 'small',
            }}
            center
            {...formIntro}
          />
        )}

        <span id={formattedId} />
      </div>
    </>
  )
}

export default ContactForm
